import React, { useState, useCallback } from 'react';

import { Row, Col } from 'antd';

import FileUploader from 'components/FileUploader';
import { useFormikContext } from 'formik';
import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  mediaPreview: any;
  setMediaPreview: (name: string, preview: any) => void;
}

const BankReceipt = ({ mediaPreview, setMediaPreview }: IProps) => {
  const { values, setSubmitting, setFieldValue } = useFormikContext<INewAccount>();
  const pathName = window.location.pathname;
  const isRefundAccount = pathName.includes('bank-account-refund');
  const [imgError, setImgError] = useState('');

  const handleUploadEvents = useCallback(
    (event: string, message?: string) => {
      if (event === 'uploading') {
        setSubmitting(true);
        return;
      }

      if (event === 'error') {
        setImgError(message);
      }
    },
    [setSubmitting]
  );

  const handleImageChange = useCallback(
    (name: string, id: number, preview: any) => {
      setMediaPreview(name, preview);

      setFieldValue('imgsIds', { ...values.imgsIds, [name]: id });
      setSubmitting(false);
    },
    [setFieldValue, setMediaPreview, setSubmitting, values.imgsIds]
  );

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <p className='text-sm font-medium'>
          Envie-nos um comprovante bancário válido e legível que comprove todos os dados bancários informados no
          formulário (passo 1).
        </p>
      </Col>

      <Col span={24}>
        <FileUploader
          onChange={handleImageChange}
          fileName='imgBankReceipt'
          defaultPreview={mediaPreview['imgBankReceipt']}
          type='image'
          uploadType='mpg_docs'
          label='Comprovante bancário'
          onEvent={handleUploadEvents}
          isRefundAccount={isRefundAccount}
        />
      </Col>

      <Col span={24}>
        <p className='m-0! text-sm font-medium'>
          Envie arquivos nos formatos: JPG, PNG ou PDF. De no máximo 2mb. <br />
        </p>
      </Col>

      {imgError ? (
        <Col span={24}>
          <div className='bank__error'>{imgError}</div>
        </Col>
      ) : (
        <></>
      )}
    </Row>
  );
};

export default BankReceipt;
